<template>
    <div class="mainDiv">
        <p class="counter">{{ counter.toLocaleString("en-IN") }} +</p>
        <p class="middletext">Progressive <b style="color: #37893c">farmers</b> and counting</p>
        <p class="bottomtext">Scroll down ⬇ to know more</p>
    </div>
</template>

<script>
export default {
    name: "farmerUserCounter",
    data() {
        return {
            counter: 0,
        };
    },
    created() {
        this.startCounter();
    },
    methods: {
        startCounter() {
          
            const interval = setInterval(() => {
                this.counter += 100000;
            
                if (this.counter == 10000000) {
                  

                    clearInterval(interval);
                 
                }
            }, 10);
         
        },
    },
    // computed: {
    //     counterHandler() {
    //         return this.counter.toLocaleString();
    //     },
    // },
};
</script>

<style lang="scss" scoped>
.mainDiv {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #f8f9f8;
    justify-content: center;
    text-align: center;
    align-items: center;
}
.counter {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 60px;
    line-height: 47px;
    margin-top: 39px;
    text-align: center;
    letter-spacing: -0.01em;
    color: #37893c;
}
@media all and (max-width: 1024px) {
    .counter {
        font-size: 43px;
        letter-spacing: -0.01em;
        margin-top: 0px;
    }
}
.middletext {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #797e79;
}
@media all and (max-width: 1024px) {
    .middletext {
        font-size: 18px;
    }
}
.bottomtext {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #797e79;
    opacity: 0.5;
}
</style>
